"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierFeeSchema = exports.TierServiceStepSchema = exports.TierCommissionStepSchema = exports.castToPaymentModel = exports.PaymentModelSchema = exports.PaymentModelType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
var PaymentModelType;
(function (PaymentModelType) {
    // Pay Redbox upfront
    PaymentModelType["PREPAY"] = "PREPAY";
    // Redbox ruby will invoice you monthly against your spend in the previous month
    PaymentModelType["ARREARS"] = "ARREARS";
    // Redbox Ruby does not deal with payments, these are done by Account Managers
    PaymentModelType["MANUAL"] = "MANUAL";
})(PaymentModelType = exports.PaymentModelType || (exports.PaymentModelType = {}));
exports.PaymentModelSchema = (0, core_1.StringUnion)([
    PaymentModelType.ARREARS,
    PaymentModelType.PREPAY,
    PaymentModelType.MANUAL,
]);
exports.castToPaymentModel = (0, cast_1.castToEnum)(PaymentModelType);
exports.TierCommissionStepSchema = (0, core_1.StrictObject)({
    minSpend: core_1.MoneySchema,
    value: core_1.PercentageSchema,
});
exports.TierServiceStepSchema = (0, core_1.StrictObject)({
    minSpend: core_1.MoneySchema,
    value: core_1.MoneySchema,
});
exports.TierFeeSchema = (0, core_1.StrictObject)({
    commission: (0, core_1.StrictObject)({
        minFee: core_1.MoneySchema,
        steps: typebox_1.Type.Array(exports.TierCommissionStepSchema),
    }),
    service: (0, core_1.StrictObject)({
        minFee: core_1.MoneySchema,
        steps: typebox_1.Type.Array(exports.TierServiceStepSchema),
    }),
});
